import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../../components/Header/Header';
import HomeBanner from '../../components/Home/HomeBanner/HomeBanner';
import HowItWorks from '../../components/Home/HowItWorks/HowItWorks';
import Testimonials from '../../components/Home/Testimonials/Testimonials';
import PaymentMethods from '../../components/PaymentMethods/PaymentMethods';
import Payment from '../../components/Home/Payment/Payment';
import AboutUs from '../../components/Home/AboutUs/AboutUs';
import Contact from '../../components/Home/Contact/Contact';
import WhatsappButton from '../../components/WhatsappButton/WhatsappButton';
import Footer from '../../components/Footer/Footer';
import './Home.css';

class Home extends Component {

  render() {
    return (
      <div>
        <Header />
        <div className="home-container">
          <HomeBanner />
          <HowItWorks />
          <PaymentMethods />
          <Testimonials />
          <AboutUs />
          <Contact />
          <Payment />
          <Footer />
          <WhatsappButton />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  test: state.test,
});

const mapDispatchToProps = (dispatch) => {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js